const serviceData = {
  hTxt: "Our Services",
  para: "From intimate family dinners to grand Indian weddings, we cater to all your needs",

  content: [
    {
      icon: "fas fa-utensils",
      title: "Dine-In Experience"
    },
    {
      icon: "fas fa-home",
      title: "Home Delivery"
    },
    {
      icon: "fas fa-birthday-cake",
      title: "Birthday Parties"
    },
    {
      icon: "fas fa-ring",
      title: "Wedding Catering"
    },
    {
      icon: "fas fa-building",
      title: "Corporate Events"
    },
    {
      icon: "fas fa-leaf",
      title: "Pure Vegetarian"
    }
  ]
};

export default serviceData;
